import React from 'react';
import KnockoutBracketView from './KnockoutBracketView';
import { pickLocalizedText } from '../../../utils/localizedContent';

export default function GroupsCompetitionView({ bracket, hasEventsPermission, onSelectMatch, onAdvanceGroups, actionLoading, lang, participantsById = {} }) {
  const inGroupStage = bracket?.phase === 'group_stage' || !bracket?.knockout;
  const text = (es, en) => pickLocalizedText(lang, es, en);
  if (!inGroupStage) {
    return (
      <div className="space-y-4">
        <h4 className="text-primary font-semibold">{text('Eliminatoria', 'Knockout stage')}</h4>
        <KnockoutBracketView
          bracket={bracket.knockout}
          hasEventsPermission={hasEventsPermission}
          onSelectMatch={onSelectMatch}
          lang={lang}
          participantsById={participantsById}
        />
      </div>
    );
  }

  return (
    <div>
      {hasEventsPermission && inGroupStage && (
        <div className="mb-4">
          <button
            onClick={onAdvanceGroups}
            disabled={actionLoading === 'groups-advance'}
            className="btn-primary px-4 py-2 text-sm"
          >
            {text('Pasar a eliminatoria', 'Advance to knockout')}
          </button>
        </div>
      )}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {(bracket?.groups || []).map((g) => (
        <div key={g.group} className="bg-card border border-border rounded-xl p-4">
          <p className="text-primary text-sm font-semibold mb-2">{text('Grupo', 'Group')} {g.group}</p>
          <div className="space-y-2 mb-3">
            {(bracket?.group_standings?.[g.group] || []).map((row) => {
              const p = row.player || {};
              const full = participantsById[p.user_id] || {};
              const avatar = full.avatar;
              const initial = (full.name || p.name || '?').charAt(0).toUpperCase();
              return (
                <div key={p.user_id} className="bg-muted/50 rounded-lg px-3 py-2 flex justify-between items-center">
                  <div className="flex items-center gap-2 min-w-0">
                    <div className="w-7 h-7 rounded-full bg-[#111827] border border-white/10 overflow-hidden flex items-center justify-center text-[11px] text-white">
                      {avatar ? (
                        <img src={avatar} alt={full.name || p.name || 'Player'} className="w-full h-full object-cover" />
                      ) : (
                        initial
                      )}
                    </div>
                    <span className="text-foreground text-sm truncate">#{row.position} {p.name}</span>
                  </div>
                  <span className="text-primary text-sm">{row.points}</span>
                </div>
              );
            })}
          </div>
          <div className="space-y-2">
            {(bracket?.group_matches || []).filter((m) => m.group === g.group).map((m) => {
              const canReport = hasEventsPermission && m.status !== 'completed';
              const p1 = m.player1 || {};
              const p2 = m.player2 || {};
              const full1 = participantsById[p1.user_id] || {};
              const full2 = participantsById[p2.user_id] || {};
              const avatar1 = full1.avatar;
              const avatar2 = full2.avatar;
              const initial1 = (full1.name || p1.name || 'T').charAt(0).toUpperCase();
              const initial2 = (full2.name || p2.name || 'T').charAt(0).toUpperCase();
              return (
                <div key={m.match_id} className="bg-muted/50 rounded-lg px-3 py-2 flex items-center justify-between">
                  <div className="flex items-center gap-2 min-w-0 text-foreground text-xs">
                    <div className="w-6 h-6 rounded-full bg-[#111827] border border-white/10 overflow-hidden flex items-center justify-center text-[10px] text-white">
                      {avatar1 ? (
                        <img src={avatar1} alt={full1.name || p1.name || 'Player 1'} className="w-full h-full object-cover" />
                      ) : (
                        initial1
                      )}
                    </div>
                    <span className="truncate">{p1.name}</span>
                    <span className="mx-1 text-muted-foreground">vs</span>
                    <div className="w-6 h-6 rounded-full bg-[#111827] border border-white/10 overflow-hidden flex items-center justify-center text-[10px] text-white">
                      {avatar2 ? (
                        <img src={avatar2} alt={full2.name || p2.name || 'Player 2'} className="w-full h-full object-cover" />
                      ) : (
                        initial2
                      )}
                    </div>
                    <span className="truncate">{p2.name}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="text-muted-foreground text-xs">{m.status === 'completed' ? `${m.score_p1}-${m.score_p2}` : text('Pendiente', 'Pending')}</span>
                    {canReport && (
                      <button onClick={() => onSelectMatch(m)} className="text-xs text-primary">
                        {text('Reportar', 'Report')}
                      </button>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        ))}
      </div>
    </div>
  );
}
